import React, { memo } from 'react';

import { Label } from '@r1-frontend/ui-react/components/label';
import { Flash } from '@r1-frontend/ui-react/components/svg/main';
import RouterCard from '@r1-frontend/ui-react/organisms/Card/Router';
import { TRouterCardCharacteristicsProps } from '@r1-frontend/ui-react/organisms/Card/Router/Router';
import { truncate } from '@r1-frontend/shared/helpers/truncate';

import { TProduct } from '~/src/features/full-buy/store/transformShopItem';

const prepareCharacteristic = <TAcc extends Array<TRouterCardCharacteristicsProps>>(acc: TAcc, elem?: {
    title: string,
    value: string,
}) => {
    if (!elem) {
        return acc;
    }

    const maxTitle = 20;
    const maxValue = 12;

    acc.push({
        ...elem,
        title: truncate(elem.title, maxTitle),
        value: truncate(elem.value, maxValue),
        Icon: Flash,
    });

    return acc;
};

interface IProps {
    product: TProduct,
    isDisabled: boolean,
    openAddEquipmentPopup: (equipment: TProduct, isInstallmentDisabled: boolean) => () => void,
    handleDecrement: (id: number) => () => void,
    handleIncrement: (id: number) => () => void,
    isSkipImages?: boolean,
}

const RouterCardView = ({
    product,
    isDisabled,
    openAddEquipmentPopup,
    handleDecrement,
    handleIncrement,
    isSkipImages,
}: IProps) => {
    const {
        id,
        image,
        images,
        title,
        categoryTitle,
        selectedPrice,
        props,
        quantity,
        labels,
    } = product;

    const slicedProps = props.slice(0, 3);

    return <RouterCard
        images={isSkipImages ? [image] : [image, ...images]}
        title={title}
        description={categoryTitle}
        characteristics={slicedProps.reduce(prepareCharacteristic, [])}
        labels={labels.map(label => (
            <Label key={label.id} bgColor={label.color}
                   textColor={label.color_text}>{label.title}</Label>
        ))}
        cost={selectedPrice.cost}
        period={selectedPrice.duration}
        quantity={quantity}
        btnText={'Подробнее'}
        onButtonClick={openAddEquipmentPopup(product, true)}
        onIncrement={handleIncrement(id)}
        onDecrement={handleDecrement(id)}
        onCostClick={openAddEquipmentPopup(product, false)}
        disabled={isDisabled}
    />;
};

export default memo(RouterCardView);
